module.exports = __webpack_public_path__ + "static/media/marketing_laptop_dark.f1dcdf5a.png";